import React, { useState, useEffect } from "react";
import LeftNav from "../../components/leftNav/LeftNav";
import TopNav from "../../components/topNav/TopNav";
import {
  Iban,
  PaymentManagement,
  Project,
  ProjectsPayment,
} from "../../utils/interfaces/interfaces";

const DetailBill: React.FC = () => {
  const [activeTab, setActiveTab] = useState("info");
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showReturnModal, setShowReturnModal] = useState(false);
  const [showCommentModal, setShowCommentModal] = useState(false);

  const [paymentManagement, setPaymentManagement] = useState<PaymentManagement>(
    {
      id: "1001",
      customerId: "C1",
      hasProjects: false,
      customer: {
        id: "C1",
        name: "Empresa ABC",
        cedulaJuridicaProveedor: "3-101-123456",
        emailProveedor: "example@domain.com",
        accountsIban: [
          {
            id: "iban1",
            name: "Cuenta Principal",
            ibanNumber: "CR12345678901234567890",
            currency: "CRC",
          },
          {
            id: "iban2",
            name: "Cuenta Secundaria",
            ibanNumber: "US09876543210987654321",
            currency: "USD",
          },
        ],
      },
      ibanId: "iban1",
      iban: {
        id: "iban1",
        name: "Cuenta Principal",
        ibanNumber: "CR12345678901234567890",
        currency: "CRC",
      },
      date: "2025-09-15",
      amount: 1200,
      state: "Pendiente",
      responsible: {
        id: "u1",
        name: "Juan Pérez",
      },
      responsibleId: "u1",
      record: [
        {
          id: "r1",
          name: "Creación de factura",
          description: "Factura creada el 2025-09-01",
        },
      ],
      department: {
        id: "1",
        name: "Finanzas",
      },
      departmentId: "1",
      companyId: "1",
      company: {
        id: "1",
        name: "Empresa ABC",
        projects: [],
      },
      details: "Servicios de consultoría",
      bill: {
        id: "b1",
        dateBill: new Date().toISOString().split("T")[0],
        numberBill: "10001",
        dueDate: new Date().toISOString().split("T")[0],
        amount: 1200,
        state: "Pendiente",
        currency: "CRC",
      },
      billId: "b1",
      companyDepartmentId: "cd1",
      companyDepartment: {
        id: "cd1",
        name: "Departamento A",
      },
      companyDepartments: [
        {
          id: "cd1",
          name: "Departamento A",
        },
      ],
    }
  );

  const [proveedores, setProveedores] = useState<
    { id: string; name: string }[]
  >([]);
  const [empresas, setEmpresas] = useState<{ id: string; name: string }[]>([]);
  const [bankAccounts, setBankAccounts] = useState<Iban[]>([]);
  const [categories, setCategories] = useState<{ id: string; name: string }[]>(
    []
  );
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);
  const [projects, setProjects] = useState<Project[]>([]);
  const [projectPayment, setProjectPayment] = useState<ProjectsPayment>({
    id: "",
    name: "",
    description: "",
    category: "",
    projectId: "",
    projectDepartmentIds: [],
  });
  const [tempSelectedLeft, setTempSelectedLeft] = useState<string[]>([]);
  const [tempSelectedRight, setTempSelectedRight] = useState<string[]>([]);

  const handleTempSelect = (id: string, side: "left" | "right") => {
    if (side === "left") {
      setTempSelectedLeft((prev) =>
        prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
      );
    } else {
      setTempSelectedRight((prev) =>
        prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
      );
    }
  };

  const handleAddSelected = () => {
    setProjectPayment((prev) => ({
      ...prev,
      projectDepartmentIds: [
        ...prev.projectDepartmentIds,
        ...tempSelectedLeft.filter(
          (id) => !prev.projectDepartmentIds.includes(id)
        ),
      ],
    }));
    setTempSelectedLeft([]);
  };

  const handleRemoveSelected = () => {
    setProjectPayment((prev) => ({
      ...prev,
      projectDepartmentIds: prev.projectDepartmentIds.filter(
        (id) => !tempSelectedRight.includes(id)
      ),
    }));
    setTempSelectedRight([]);
  };

  /*
    id: string;
    name: string;
    description: string;
    projectDepartments: ProjectDepartment[];

      id: string;
  name: string;
  projectId: string;
  */
  const mockProjects: Project[] = [
    {
      id: "p1",
      name: "Proyecto A",
      description: "Descripción del Proyecto A",
      projectDepartments: [
        { id: "d1", name: "Apartamento 1", projectId: "p1" },
        { id: "d2", name: "Apartamento 2", projectId: "p1" },
      ],
    },
    {
      id: "p2",
      name: "Proyecto B",
      description: "Descripción del Proyecto B",
      projectDepartments: [
        { id: "d3", name: "Apartamento 3", projectId: "p2" },
        { id: "d4", name: "Apartamento 4", projectId: "p2" },
      ],
    },
  ];

  useEffect(() => {
    setProveedores([
      { id: "C1", name: "Proveedor A" },
      { id: "C2", name: "Proveedor B" },
      { id: "C3", name: "Proveedor C" },
    ]);
    setEmpresas([
      { id: "1", name: "Empresa XYZ" },
      { id: "2", name: "Empresa ABC" },
      { id: "3", name: "Empresa 123" },
    ]);
    setBankAccounts([
      {
        id: "iban1",
        name: "Cuenta Principal",
        ibanNumber: "CR12345678901234567890",
        currency: "CRC",
      },
      {
        id: "iban2",
        name: "Cuenta Secundaria",
        ibanNumber: "US09876543210987654321",
        currency: "USD",
      },
    ]);
    setCategories([
      { id: "1", name: "Viáticos" },
      { id: "2", name: "Servicios" },
      { id: "3", name: "Materiales" },
      { id: "4", name: "Otros" },
    ]);
    setProjects(mockProjects);
  }, []);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setPaymentManagement((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeProjectsPayment = (
    field: keyof ProjectsPayment,
    value: string | string[]
  ) => {
    setProjectPayment((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Pago guardado:", paymentManagement);
  };

  useEffect(() => {
    // Simular fetch de datos de la factura
    const fakeFacturas: PaymentManagement[] = [
      {
        id: "1001",
        customerId: "C1",
        hasProjects: false,
        customer: {
          id: "C1",
          name: "Empresa ABC",
          cedulaJuridicaProveedor: "3-101-123456",
          emailProveedor: "example@domain.com",
          accountsIban: [
            {
              id: "iban1",
              name: "Cuenta Principal",
              ibanNumber: "CR12345678901234567890",
              currency: "CRC",
            },
            {
              id: "iban2",
              name: "Cuenta Secundaria",
              ibanNumber: "US09876543210987654321",
              currency: "USD",
            },
          ],
        },
        ibanId: "iban1",
        iban: {
          id: "iban1",
          name: "Cuenta Principal",
          ibanNumber: "CR12345678901234567890",
          currency: "CRC",
        },
        date: "2025-09-15",
        amount: 1200,
        state: "Pendiente",
        responsible: {
          id: "u1",
          name: "Juan Pérez",
        },
        responsibleId: "u1",
        record: [
          {
            id: "r1",
            name: "Creación de factura",
            description: "Factura creada el 2025-09-01",
          },
        ],
        department: {
          id: "1",
          name: "Finanzas",
        },
        departmentId: "1",
        companyId: "1",
        company: {
          id: "1",
          name: "Empresa ABC",
          projects: [],
        },
        details: "Servicios de consultoría",
        bill: {
          id: "b1",
          dateBill: new Date().toISOString().split("T")[0],
          numberBill: "10001",
          dueDate: new Date().toISOString().split("T")[0],
          amount: 1200,
          state: "Pendiente",
          currency: "CRC",
        },
        billId: "b1",
        companyDepartmentId: "cd1",
        companyDepartment: {
          id: "cd1",
          name: "Departamento A",
        },
        companyDepartments: [
          {
            id: "cd1",
            name: "Departamento A",
          },
        ],
      },
      {
        id: "1002",
        customerId: "C2",
        hasProjects: false,
        customer: {
          id: "C2",
          name: "Servicios XYZ",
          cedulaJuridicaProveedor: "3-101-123456",
          emailProveedor: "example@domain.com",
          accountsIban: [
            {
              id: "iban1",
              name: "Cuenta Principal",
              ibanNumber: "CR12345678901234567890",
              currency: "CRC",
            },
            {
              id: "iban2",
              name: "Cuenta Secundaria",
              ibanNumber: "US09876543210987654321",
              currency: "USD",
            },
          ],
        },
        ibanId: "iban2",
        iban: {
          id: "iban2",
          name: "Cuenta Secundaria",
          ibanNumber: "US09876543210987654321",
          currency: "USD",
        },
        date: "2025-09-15",
        amount: 2010,
        state: "Aprobada",
        responsible: {
          id: "u1",
          name: "Juan Pérez",
        },
        responsibleId: "u1",
        record: [
          {
            id: "r1",
            name: "Creación de factura",
            description: "Factura creada el 2025-09-01",
          },
        ],
        department: {
          id: "2",
          name: "Compras",
        },
        departmentId: "2",
        companyId: "2",
        company: {
          id: "2",
          name: "Servicios XYZ",
          projects: [],
        },
        details: "Servicios de consultoría",
        bill: {
          id: "b2",
          dateBill: new Date().toISOString().split("T")[0],
          numberBill: "10002",
          dueDate: new Date().toISOString().split("T")[0],
          amount: 1200,
          state: "Pendiente",
          currency: "USD",
        },
        billId: "b2",
        companyDepartmentId: "cd1",
        companyDepartment: {
          id: "cd1",
          name: "Departamento A",
        },
        companyDepartments: [
          {
            id: "cd1",
            name: "Departamento A",
          },
        ],
      },
    ];

    const billId = window.location.pathname.split("/").pop();
    const billData = fakeFacturas.find((b) => b.id.toString() === billId);
    if (billData) {
      setPaymentManagement((prev) => ({
        ...prev,
      }));
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 flex">
      <LeftNav />

      <main className="flex-1">
        <TopNav />

        <div className="max-w-5xl mx-auto bg-white shadow rounded-lg p-6 mt-6">
          <div className="border-b mb-4 flex">
            <button
              onClick={() => setActiveTab("info")}
              className={`px-4 py-2 ${
                activeTab === "info"
                  ? "border-b-2 border-blue-600 font-semibold"
                  : "text-gray-500"
              }`}
            >
              Información
            </button>
            <button
              onClick={() => setActiveTab("proyectos")}
              className={`px-4 py-2 disabled:cursor-not-allowed disabled:bg-slate-100 ${
                activeTab === "historial"
                  ? "border-b-2 border-blue-600 font-semibold"
                  : "text-gray-500"
              }`}
              disabled={paymentManagement.hasProjects === false}
            >
              Proyectos
            </button>
            <button
              onClick={() => setActiveTab("historial")}
              className={`px-4 py-2 ${
                activeTab === "historial"
                  ? "border-b-2 border-blue-600 font-semibold"
                  : "text-gray-500"
              }`}
            >
              Historial
            </button>
          </div>

          {activeTab === "info" && (
            <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-semibold mb-1">
                  Fecha de Factura
                </label>
                <input
                  type="date"
                  name="fechaFactura"
                  value={paymentManagement.bill.dateBill}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                  disabled
                />
              </div>

              <div>
                <label className="block text-sm font-semibold mb-1">
                  Número de Factura
                </label>
                <input
                  type="text"
                  name="numeroFactura"
                  value={paymentManagement.bill.numberBill}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                  disabled
                />
              </div>

              <div>
                <label className="block text-sm font-semibold mb-1">
                  Fecha de Vencimiento
                </label>
                <input
                  type="date"
                  name="fechaVencimiento"
                  value={paymentManagement.bill.dueDate}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                  disabled
                />
              </div>

              <div>
                <label className="block text-sm font-semibold mb-1">
                  Empresa a la que se Factura
                </label>
                <select
                  name="empresaId"
                  value={paymentManagement.companyId}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                >
                  <option value="">Selecciona una empresa</option>
                  {empresas.map((e) => (
                    <option key={e.id} value={e.id}>
                      {e.name}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-semibold mb-1">
                  Proveedor
                </label>
                <select
                  name="proveedorId"
                  value={paymentManagement.customerId}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                >
                  <option value="">Selecciona un proveedor</option>
                  {proveedores.map((p) => (
                    <option key={p.id} value={p.id}>
                      {p.name}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-semibold mb-1">
                  Cédula Jurídica del Proveedor
                </label>
                <input
                  type="text"
                  name="cedulaJuridicaProveedor"
                  value={paymentManagement.customer.cedulaJuridicaProveedor}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                  disabled
                />
              </div>

              <div>
                <label className="block text-sm font-semibold mb-1">
                  Email del Proveedor
                </label>
                <input
                  type="email"
                  name="emailProveedor"
                  value={paymentManagement.customer.emailProveedor}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                  disabled
                />
              </div>

              <div>
                <label className="block text-sm font-semibold mb-1">
                  Tipo de Moneda
                </label>
                <select
                  name="currency"
                  value={paymentManagement.bill.currency}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                  disabled
                >
                  <option value="CRC">Colones</option>
                  <option value="USD">Dólares</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-semibold mb-1">
                  Cuenta Bancaria
                </label>

                <select
                  name="ibanId"
                  value={paymentManagement.ibanId}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                >
                  <option value="">Selecciona una cuenta</option>
                  {bankAccounts
                    .filter(
                      (acc) => acc.currency === paymentManagement.bill.currency
                    )
                    .map((acc) => (
                      <option key={acc.id} value={acc.id}>
                        {acc.name} - {acc.ibanNumber}
                      </option>
                    ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-semibold mb-1">
                  Monto en{" "}
                  {paymentManagement.bill.currency === "CRC"
                    ? "Colones"
                    : "Dólares"}
                </label>
                <input
                  type="number"
                  name="amount"
                  value={paymentManagement.amount}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                  disabled
                />
              </div>

              <div>
                <label className="block text-sm font-semibold mb-1">
                  Tiene Proyectos
                </label>
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    name="hasProjects"
                    checked={paymentManagement.hasProjects}
                    onChange={(e) =>
                      setPaymentManagement((prev) => ({
                        ...prev,
                        hasProjects: e.target.checked,
                      }))
                    }
                    className="h-5 w-5"
                  />
                  <span className="ml-2 text-gray-700">Sí</span>
                </div>
                <div>
                  <span className="text-sm text-gray-500">
                    (Habilita la pestaña de Proyectos)
                  </span>
                </div>
              </div>

              <div className="col-span-2">
                <label className="block text-sm font-semibold mb-1">
                  Concepto
                </label>
                <textarea
                  name="concepto"
                  value={paymentManagement.details}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                />
              </div>

              <div className="col-span-2 flex justify-end gap-4 mt-4">
                <button
                  onClick={() => setShowReturnModal(true)}
                  className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded"
                >
                  {" "}
                  Devolver{" "}
                </button>{" "}
                <button
                  onClick={() => setShowApproveModal(true)}
                  className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
                >
                  {" "}
                  Aprobar{" "}
                </button>
              </div>
            </form>
          )}

          {activeTab === "historial" && (
            <div>
              <div className="flex justify-between mb-4">
                <input type="date" className="border px-3 py-2 rounded w-1/3" />
                <button
                  onClick={() => setShowCommentModal(true)}
                  className="bg-blue-600 text-white px-4 py-2 rounded"
                >
                  Agregar Comentario
                </button>
              </div>

              <table className="w-full border text-left">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="p-2 border">Fecha</th>
                    <th className="p-2 border">Acción</th>
                    <th className="p-2 border">Usuario</th>
                    <th className="p-2 border">Comentario</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="p-2 border">2025-09-21</td>
                    <td className="p-2 border">Resivionn</td>
                    <td className="p-2 border">Ana</td>
                    <td className="p-2 border">
                      Se reviso la información ingresada
                    </td>
                  </tr>
                  <tr>
                    <td className="p-2 border">2025-09-20</td>
                    <td className="p-2 border">Factura creada</td>
                    <td className="p-2 border">Eduardo</td>
                    <td className="p-2 border">Se subió la Factura</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
          {activeTab === "proyectos" && (
            <div className="space-y-4 border p-4 rounded-lg bg-white shadow">
              <h2 className="text-lg font-semibold text-gray-800">
                Pago de proyecto
              </h2>

              {/* Proyecto */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Proyecto
                </label>
                <select
                  value={projectPayment.projectId}
                  onChange={(e) => {
                    handleChangeProjectsPayment("projectId", e.target.value);
                    const proj =
                      projects.find((p) => p.id === e.target.value) || null;
                    setSelectedProject(proj);
                    // Reinicia los apartamentos seleccionados al cambiar de proyecto
                    setProjectPayment((prev) => ({
                      ...prev,
                      projectDepartmentIds: [],
                    }));
                  }}
                  className="w-full border px-3 py-2 rounded"
                >
                  <option value="">Seleccione un proyecto</option>
                  {projects.map((proj) => (
                    <option key={proj.id} value={proj.id}>
                      {proj.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Apartamentos (2 columnas con checkboxes) */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Apartamentos
                </label>

                {!selectedProject ? (
                  <p className="text-sm text-gray-500">
                    Seleccione primero un proyecto para ver sus apartamentos.
                  </p>
                ) : (
                  <div className="grid grid-cols-2 gap-4">
                    {/* Columna izquierda: NO seleccionados */}
                    <div className="border rounded p-3">
                      <h3 className="text-sm font-semibold mb-2 text-gray-700">
                        No seleccionados
                      </h3>
                      {selectedProject.projectDepartments
                        .filter(
                          (dept) =>
                            !projectPayment.projectDepartmentIds.includes(
                              dept.id
                            )
                        )
                        .map((dept) => (
                          <div
                            key={dept.id}
                            className="flex items-center space-x-2"
                          >
                            <input
                              type="checkbox"
                              value={dept.id}
                              checked={tempSelectedLeft.includes(dept.id)}
                              onChange={(e) =>
                                handleTempSelect(e.target.value, "left")
                              }
                              className="cursor-pointer"
                            />
                            <label className="text-sm">{dept.name}</label>
                          </div>
                        ))}
                    </div>

                    {/* Columna derecha: seleccionados */}
                    <div className="border rounded p-3">
                      <h3 className="text-sm font-semibold mb-2 text-gray-700">
                        Seleccionados
                      </h3>
                      {selectedProject.projectDepartments
                        .filter((dept) =>
                          projectPayment.projectDepartmentIds.includes(dept.id)
                        )
                        .map((dept) => (
                          <div
                            key={dept.id}
                            className="flex items-center space-x-2"
                          >
                            <input
                              type="checkbox"
                              value={dept.id}
                              checked={tempSelectedRight.includes(dept.id)}
                              onChange={(e) =>
                                handleTempSelect(e.target.value, "right")
                              }
                              className="cursor-pointer"
                            />
                            <label className="text-sm">{dept.name}</label>
                          </div>
                        ))}
                    </div>
                  </div>
                )}

                {/* Botones de acción */}
                {selectedProject && (
                  <div className="flex justify-center items-center space-x-4 mt-3">
                    <button
                      onClick={handleAddSelected}
                      className="flex items-center gap-2 bg-green-600 text-white px-4 py-1 rounded hover:bg-green-700 transition"
                    >
                      Agregar
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-4 h-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M9 5l7 7-7 7"
                        />
                      </svg>
                    </button>

                    <button
                      onClick={handleRemoveSelected}
                      className="flex items-center gap-2 bg-red-600 text-white px-4 py-1 rounded hover:bg-red-700 transition"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-4 h-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M15 19l-7-7 7-7"
                        />
                      </svg>
                      Remover
                    </button>
                  </div>
                )}
              </div>

              {/* Categoría */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Categoría
                </label>
                <select
                  value={projectPayment.category}
                  onChange={(e) =>
                    handleChangeProjectsPayment("category", e.target.value)
                  }
                  className="w-full border px-3 py-2 rounded"
                >
                  <option value="">Seleccione una categoría</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Descripcion
                </label>
                <textarea
                  value={projectPayment.description}
                  onChange={(e) =>
                    handleChangeProjectsPayment("description", e.target.value)
                  }
                  className="w-full border px-3 py-2 rounded"
                />
              </div>

              {/* Botón Guardar */}
              <button
                onClick={handleSubmit}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                Guardar
              </button>
            </div>
          )}
        </div>
      </main>

      {showApproveModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center">
          <div className="bg-white p-6 rounded shadow w-96">
            <h3 className="text-lg font-bold mb-2">Aprobar Factura</h3>
            <textarea
              className="w-full border rounded p-2 mb-4"
              placeholder="Agregar nota(Opcional)"
            ></textarea>
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowApproveModal(false)}
                className="px-4 py-2 bg-gray-300 rounded"
              >
                Cancelar
              </button>
              <button className="px-4 py-2 bg-green-600 text-white rounded">
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}

      {showReturnModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center">
          <div className="bg-white p-6 rounded shadow w-96">
            <h3 className="text-lg font-bold mb-2">Devolver Factura</h3>
            <select className="w-full border rounded p-2 mb-2">
              <option>Razón: Documento incorrecto</option>
              <option>Razón: Monto inconsistente</option>
              <option>Razón: Falta información</option>
            </select>
            <textarea
              className="w-full border rounded p-2 mb-4"
              placeholder="Comentario"
            ></textarea>
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowReturnModal(false)}
                className="px-4 py-2 bg-gray-300 rounded"
              >
                Cancelar
              </button>
              <button className="px-4 py-2 bg-red-600 text-white rounded">
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}

      {showCommentModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center">
          <div className="bg-white p-6 rounded shadow w-96">
            <h3 className="text-lg font-bold mb-2">Agregar Comentario</h3>
            <textarea
              className="w-full border rounded p-2 mb-4"
              placeholder="Escribe un comentario"
            ></textarea>
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowCommentModal(false)}
                className="px-4 py-2 bg-gray-300 rounded"
              >
                Cancelar
              </button>
              <button className="px-4 py-2 bg-blue-600 text-white rounded">
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailBill;
